import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import Card, { CardBody } from '../../components/bootstrap/Card';
import PageWrapper from '../PageWrapper/PageWrapper';
import Page from '../Page/Page';
import SubHeader from '../SubHeader/SubHeader';
import ContentRoutes from './ContentRoutes';
import ErrorBoundary from '../../components/ErrorBoundary';

const _loading = (
	<PageWrapper>
		<SubHeader>
			<div />
		</SubHeader>
		<Page>
			<div className='row h-100'>
				<div className='col-lg-6'>
					<Card stretch>
						<CardBody>
							<div />
						</CardBody>
					</Card>
				</div>
				<div className='col-lg-6'>
					<Card stretch='semi'>
						<CardBody>
							<div />
						</CardBody>
					</Card>
					<Card stretch='semi'>
						<CardBody>
							<div />
						</CardBody>
					</Card>
				</div>
			</div>
		</Page>
	</PageWrapper>
);

const Content = () => {
	const { pathname } = useLocation();
	return (
		<main className='content'>
			<ErrorBoundary key={pathname}>
				<Suspense fallback={_loading}>
					<ContentRoutes />
				</Suspense>
			</ErrorBoundary>
		</main>
	);
};

export default Content;
